module.exports = __webpack_public_path__ + "img/icon_message_fail.8ba3893f.png";